import styled from 'styled-components6';
import { ContentSource } from 'rwl-shared/dist/models/ContentSource';
import { SourceIcon } from '../SourceIcon';

export interface ReviewRatingProps {
    rating: number;
    size: 'small' | 'large';
    source?: ContentSource;
}

interface StarProps {
    size: 'small' | 'large';
    fill: string;
}

const StarRow = styled.span`
    display: flex;
    gap: var(--rwl-spacing-xs);
    & svg {
        display: inline-flex;
    }
`;

function Star({ fill, size }: StarProps): JSX.Element {
    return (
        <svg
            height={size === 'small' ? '12px' : '16px'}
            focusable="false"
            className="rwlRatingStar"
            style={{ fill }}
            viewBox="0 0 576 512"
        >
            <path d="M316.7 17.8l65.43 132.4l146.4 21.29c26.27 3.796 36.79 36.09 17.75 54.59l-105.9 102.1l25.05 145.5c4.508 26.31-23.23 45.9-46.49 33.7L288 439.6l-130.9 68.7C133.8 520.5 106.1 500.9 110.6 474.6l25.05-145.5L29.72 226.1c-19.03-18.5-8.516-50.79 17.75-54.59l146.4-21.29l65.43-132.4C271.1-6.083 305-5.786 316.7 17.8z" />
        </svg>
    );
}

export const ReviewRating = ({
    rating,
    source,
    size,
}: ReviewRatingProps): JSX.Element => {
    const stars = [];
    const count = Math.min(Math.max(rating, 0), 5);
    for (let i = 0; i < 5; i++) {
        stars.push(
            <Star
                key={i}
                size={size}
                fill={i < count ? '#FFB400' : 'var(--rwl-palette-gray-200)'}
            />
        );
    }
    return (
        <>
            {source && source !== ContentSource.Internal && (
                <SourceIcon
                    style={{ marginRight: 'var(--rwl-spacing-sm)' }}
                    source={source}
                />
            )}
            <StarRow className="rwlStarRow">{stars}</StarRow>
        </>
    );
};
